import ShortcutValueLabel from './ShortcutValueLabel';

export default ShortcutValueLabel;
